function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
import "core-js/modules/es.object.get-prototype-of.js";
import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
var _excluded = ["size", "sizeMultiplier", "title", "name", "className", "selected", "ariaLabel", "directional", "decorative", "id"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.function.name.js";
/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2017,2019. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */

import React from 'react';
import PropTypes from 'prop-types';
import { uniqueIdForComponent, iconSpriteSheet, ICON_SIZES, sizeForIcon } from '../util';
import Icon from './Icon';
var propTypes = {
  /** id of the svg element */
  id: PropTypes.string,
  /**
   title for the icon, used by screen readers
  */
  title: PropTypes.string,
  /**
  size specifier
  */
  size: PropTypes.oneOf(ICON_SIZES),
  /**
  name of the icon as specified in the icon set
  */
  name: PropTypes.string.isRequired,
  /**
  additional styling
  */
  className: PropTypes.string,
  /**
   size multiplier used to provide custom icon size, small size 16 x multiplier
   */
  sizeMultiplier: PropTypes.number,
  /** specifies if the icon is selected */
  selected: PropTypes.bool,
  /** used by screen readers to describe a non-decorative icon */
  ariaLabel: function ariaLabel(props, propName, componentName) {
    if (props.decorative === false && (props[propName] === undefined || typeof props[propName] !== 'string')) {
      return new Error("A non-decorative ".concat(componentName, " expects an ").concat(propName));
    }
    return null;
  },
  /** decorative icons are hidden from screen readers, ariaLabel not required */
  decorative: PropTypes.bool,
  /** The the direction of the icon is important in RTL mode */
  directional: PropTypes.bool
};
var defaultProps = {
  title: undefined,
  id: undefined,
  ariaLabel: undefined,
  size: 'small',
  className: undefined,
  sizeMultiplier: 1,
  selected: false,
  directional: true,
  decorative: false
};
var IconSet = /*#__PURE__*/function (_React$Component) {
  _inherits(IconSet, _React$Component);
  var _super = _createSuper(IconSet);
  function IconSet(props) {
    var _this;
    _classCallCheck(this, IconSet);
    _this = _super.call(this, props);
    _this.state = {
      id: _this.props.id || uniqueIdForComponent(_assertThisInitialized(_this))
    };
    return _this;
  }
  _createClass(IconSet, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        size = _this$props.size,
        sizeMultiplier = _this$props.sizeMultiplier,
        title = _this$props.title,
        name = _this$props.name,
        className = _this$props.className,
        selected = _this$props.selected,
        ariaLabel = _this$props.ariaLabel,
        directional = _this$props.directional,
        decorative = _this$props.decorative,
        id = _this$props.id,
        otherProps = _objectWithoutProperties(_this$props, _excluded);
      var iconSize = sizeForIcon(size);
      return /*#__PURE__*/React.createElement(Icon, _extends({
        id: this.state.id,
        size: size,
        sizeMultiplier: sizeMultiplier,
        title: title,
        path: "".concat(iconSpriteSheet, "#").concat(name, "-").concat(iconSize),
        selected: selected,
        directional: directional,
        ariaLabel: ariaLabel,
        decorative: decorative,
        className: className
      }, otherProps));
    }
  }]);
  return IconSet;
}(React.Component);
IconSet.propTypes = propTypes;
IconSet.defaultProps = defaultProps;
IconSet.displayName = 'IconSet';
export default IconSet;